import { render, staticRenderFns } from "./ControlBtnsTemplate.vue?vue&type=template&id=be87c552&scoped=true&"
import script from "./ControlBtnsTemplate.vue?vue&type=script&lang=js&"
export * from "./ControlBtnsTemplate.vue?vue&type=script&lang=js&"
import style0 from "./ControlBtnsTemplate.vue?vue&type=style&index=0&id=be87c552&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be87c552",
  null
  
)

export default component.exports